import { LoginComponent } from '@ixigo-packages/login';
import { ReactNode } from 'react';
import { getLoginConfig } from './utils/login';

type LoginWrapperProps = {
    children: ReactNode;
};

function LoginWrapper({ children }: LoginWrapperProps) {
    const loginConfig = getLoginConfig();
    return <LoginComponent config={loginConfig}>{children}</LoginComponent>;
}

export { LoginWrapper };
